import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { getAllFuelTypesAPI, getSingleFuelTypesAPI } from "./fuelTypes.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

type IFuelTypesServiceProps = Omit<IGetAllServiceProps, "stage_id">;

const useAllFuelTypesService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: IFuelTypesServiceProps) => {
  const [searchFuelTypesQuery, setSearchFuelTypesQuery] = useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchFuelTypesQuery);
  const allFuelTypesService = useQuery({
    queryKey: [...CACHE_KEYS.FUEL_TYPES, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllFuelTypesAPI({
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchFuelTypesQuery, setSearchFuelTypesQuery },
    services: { allFuelTypesService },
  };
};

const useSingleFuelTypesService = ({
  singleFuelTypesId,
  enableQuery = true,
}: {
  singleFuelTypesId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.FUEL_TYPES, singleFuelTypesId],
    queryFn: () => getSingleFuelTypesAPI(singleFuelTypesId),
    enabled: !!singleFuelTypesId && enableQuery,
  });
};

export { useAllFuelTypesService, useSingleFuelTypesService };
